const applyFeature = (feature_flag: string) => {
  return localStorage.getItem(feature_flag) === "true"
}

export default applyFeature
